<template>
  <div class="white-card">
    <div class="white-card-header">
      <div class="title-wrap">
        <label class="title-label">{{label.get('job_codes')}}</label>
        <!--<i class="atto info-icon"
          id="tooltip-job-codes"></i>
        <b-tooltip
            target="tooltip-job-codes"
            custom-class="info-tooltip"
            placement="bottom" >
          <label>Job Codes</label>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
        </b-tooltip>-->
      </div>

      <button
          class="view-btn"
          @click="viewAllJobCodes"
          v-if="jobCodes.length > 5"
      >
        <i class="atto atto atto-rdir-arrow-b" />
        {{ label.get('view_all') }}
      </button>
    </div>
    <div class="d-flex flex-column" v-if="jobCodes.length">
      <div class="job-code-header justify-content-between align-items-center d-flex flex-row">
        <label class="job-code">{{label.get('job_code')}}</label>
        <label class="hours">{{label.get('hours')}}</label>
      </div>
      <div class="job-codes-body d-flex flex-column hasScroll">
        <perfect-scrollbar>
          <div v-for="(item, idx) in firstFiveJobCodes" :key="idx" class="d-flex flex-row justify-content-between align-items-center">
            <span class="job-code">{{item.name}}</span>
            <span class="hours">{{item.amount}}</span>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <div class="no-job-codes-tracked" v-if="!jobCodes.length">
      <i class="no-job-codes-tracked-icon" />
      <p>{{ label.get('no_job_codes_tracked') }}</p>
    </div>
    <all-job-codes-component v-if="showAllJobCodes" :job-codes="jobCodes" />
  </div>

</template>

<script>
  import AllJobCodesComponent from "./AllJobCodesComponent";

  export default {
    name: "TimesheetJobCodesComponent",
    props: {
      jobCodes: {
        type: Array,
        default: []
      },
    },
    components: {
      AllJobCodesComponent
    },
    data() {
      return {
        showAllJobCodes: false
      }
    },
    computed: {
      firstFiveJobCodes() {
        return this.jobCodes.slice(0, 5);
      }
    },
    mounted() {
      this.$root.$on('hideAllJobCodes', this.hideAllJobCodes);
    },
    methods: {
      viewAllJobCodes() {
        this.showAllJobCodes = true;
      },
      hideAllJobCodes() {
        this.showAllJobCodes = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .white-card{
    overflow: hidden;
    height: 268px !important;
  }
  .job-code-header{
    height: 35px;
    background-color: #FAFAFA;
    padding: 12px 10px 12px 20px;
    align-items: center;

    label{
      color: #666666;
      margin: 0;
      letter-spacing: 0.5px;
      font: 500 0.625rem/0.6875rem $roboto-font;
      text-transform: uppercase;
      width: 70%;

      &.hours{
       /* width: 152px; */
        min-width: 62px;
        width: 30%;
        text-align: left;
      }
    }


  }
  .job-codes-body{
    .flex-row{
      border-top: 1px solid #efefef;
      padding: 5px 10px 6px 20px;
      height: 35px;

      span{
        color: $atto-font-color;

        &.hours{
          /*width: 152px;*/
          min-width: 62px;
          width: 30%;
          text-align: left;
          font: 400 0.8125rem/0.9375rem $roboto-font;
        }
        &.job-code{
          width: 70%;
          font: 400 0.875rem/1.5rem $roboto-font;
        }
      }
    }

    .ps{
      max-height: 175px;
    }
  }
  .no-job-codes-tracked{
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    border-top: 1px solid $atto-light-grey;
    height: 100%;

    i.no-job-codes-tracked-icon{
      width: 51px;
      height: 48px;
      background: url('~@assets/images/no_job_codes_tracked.svg') no-repeat center;
    }
    p{
      font: $roboto-regular 1rem/1.75rem $roboto-font;
      color: $atto-font-color;
      margin: 8px 0 0 0;
    }
  }
</style>